import { render, staticRenderFns } from "./RegistroNovedades2.vue?vue&type=template&id=71f4b68c"
import script from "./RegistroNovedades2.vue?vue&type=script&lang=js"
export * from "./RegistroNovedades2.vue?vue&type=script&lang=js"
import style0 from "./RegistroNovedades2.vue?vue&type=style&index=0&id=71f4b68c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports